import React from 'react';
import { PlayerRoundScore, GameMode } from '@shared/types';

interface ResultScreenProps {
  scores: PlayerRoundScore[];
  mode: GameMode;
  onPlayAgain: () => void;
  onMainMenu: () => void;
}

export const ResultScreen: React.FC<ResultScreenProps> = ({
  scores,
  mode,
  onPlayAgain,
  onMainMenu,
}) => {
  const sorted = [...scores].sort((a, b) => b.totalScore - a.totalScore);
  const winner = sorted[0];

  return (
    <div className="result-overlay">
      <div className="result-card" style={{ minWidth: 360 }}>
        <div className="result-title">🏆 OYUN BİTTİ</div>

        <div style={{
          textAlign: 'center',
          marginBottom: 20,
          fontSize: 15,
          color: 'var(--gold-light)',
        }}>
          Kazanan: <strong>{winner?.nickname}</strong>
        </div>

        <div style={{
          fontSize: 11,
          color: 'var(--text-muted)',
          textAlign: 'center',
          marginBottom: 12,
          letterSpacing: 1,
          textTransform: 'uppercase',
        }}>
          {mode === '101' ? '101 Okey' : 'Normal Okey'} — Final Skorlar
        </div>

        <table className="score-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Oyuncu</th>
              <th>Toplam Puan</th>
            </tr>
          </thead>
          <tbody>
            {sorted.map((s, i) => (
              <tr key={s.playerId} className={i === 0 ? 'winner' : ''}>
                <td style={{ color: i === 0 ? 'var(--gold-light)' : 'var(--text-muted)', fontWeight: 700 }}>
                  {i === 0 ? '🥇' : i === 1 ? '🥈' : i === 2 ? '🥉' : `${i + 1}.`}
                </td>
                <td>{s.nickname}</td>
                <td className={s.totalScore >= 0 ? 'score-positive' : 'score-negative'}>
                  {s.totalScore}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div style={{ display: 'flex', gap: 10, marginTop: 8 }}>
          <button className="btn btn-ghost" style={{ flex: 1 }} onClick={onMainMenu}>
            ANA MENÜ
          </button>
          <button className="btn btn-green btn-lg" style={{ flex: 1 }} onClick={onPlayAgain}>
            TEKRAR OYNA
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResultScreen;
